import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal, UpsertTemplateForm } from "src/app/components";
import { useAvailableTagsOptions } from "src/app/hooks";
import { TemplatesTransport } from "src/app/transports/templates";
import { LangType } from "src/app/types/LangType";
import { TagType } from "src/app/types/Message";
import { Template, TemplateDTOSchema, UpsetTemplateDTO } from "src/app/types/templates";
export interface IUpsertTemplateFormContainer {
    template?: Template;
    currentCategory?: string;
    currentLang: LangType;
    templateList?: Array<Template>;
    handleClose(): void;
    showModal: boolean;
}
const UpsertTemplateFormContainer = (props: IUpsertTemplateFormContainer) => {
    const { handleClose = () => {}, template, showModal, currentLang } = props;

    const { formatMessage } = useIntl();

    const {
        tagsOptions,
        loading: tagsLoading,
        refresh,
    } = useAvailableTagsOptions(currentLang, template?.tag ? TagType[template?.tag] : null);

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (_values: UpsetTemplateDTO) => {
        setLoading(true);
        try {
            await TemplatesTransport.save(_values, template?.id);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };
    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.action.template" })}
            showModal={showModal}
            handleClose={handleClose}
            formId="upsertTemplates"
            loading={loading}
            modalProps={{ fullscreen: true }}
        >
            <Formik
                initialValues={
                    template
                        ? TemplatesTransport.formTransformer(template)
                        : ({ ...TemplateDTOSchema.getDefault(), lang: currentLang } as any)
                }
                validationSchema={TemplateDTOSchema}
                onSubmit={handleSubmit}
            >
                <Form id="upsertTemplates">
                    <UpsertTemplateForm
                        tagsOptions={{
                            options: tagsOptions,
                            loading: tagsLoading,
                            refresh,
                        }}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};
export default UpsertTemplateFormContainer;
